import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import styles from "../static/styles/Rewards.module.css";

import ArrowLeft from "../static/img/backArrow.png";

import { getRewardsList } from "../api/rewards";
import { isAuthenticated } from "../api/auth";

import MessagePopup from "../components/MessagePopup";
import GameNowPopup from "../components/GameNowPopup";

import { jwtDecode } from "jwt-decode";
import { trackRewardRedemptionAttempt } from "../utils/analytics";

import playstation5Img from "../static/img/Rewards/ps5.png";
import asusRogDeltaSCoreImg from "../static/img/Rewards/AsusROGDeltaSCoreGamingHeadphone.avif";
import edifierG1Img from "../static/img/Rewards/g2.png";
import asusTufKeyboardImg from "../static/img/Rewards/tufk3rd.png";
import bloodyB760Img from "../static/img/Rewards/b865n.png";
import asusGladiusImg from "../static/img/Rewards/gladius3.png";
import pubgImg from "../static/img/Rewards/pubguc.png";
import fortniteImg from "../static/img/Rewards/fbuks.png";
import minecraftImg from "../static/img/Rewards/minecraft.png";
import coinImg from "../static/img/Rewards/coin.png";
import zeroHeadphones from "../static/img/Rewards/zeroHeadphones.png";
import zeroEarbuds from "../static/img/Rewards/zeroEarbuds.png";
import zeroWatch from "../static/img/Rewards/zeroWatch.png";


const Rewards = () => {
  const [message, setMessage] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [showGameNow, setShowGameNow] = useState(false);
  const [rewardsData, setRewardsData] = useState([]);
  const [loadingRewards, setLoadingRewards] = useState(true);
  const [errorRewards, setErrorRewards] = useState(null);

  const navigate = useNavigate();

  const getRewardImage = (rewardName) => {
    if (!rewardName) return "";

    const name = rewardName.toLowerCase();

    if (name.includes("playstation")) return playstation5Img;
    if (name.includes("asus rog") && name.includes("headphone"))
      return asusRogDeltaSCoreImg;
    if (name.includes("edifier")) return edifierG1Img;
    if (name.includes("zero lifestyle headphones")) return zeroHeadphones;
    if (name.includes("zero lifestyle watch")) return zeroWatch;
    if (name.includes("zero lifestyle earbuds")) return zeroEarbuds;
    if (name.includes("asus") && name.includes("keyboard"))
      return asusTufKeyboardImg;
    if (name.includes("bloody")) return bloodyB760Img;
    if (name.includes("asus rog") && name.includes("mouse"))
      return asusGladiusImg;
    if (name.includes("pubg")) return pubgImg;
    if (name.includes("fortnite")) return fortniteImg;
    if (name.includes("minecraft")) return minecraftImg;

    return "";
  };

  useEffect(() => {
    document.title = "Rewards | Ufone ESG";
  }, []);

  useEffect(() => {
    const loadRewards = async () => {
      try {
        setLoadingRewards(true);
        setErrorRewards(null);

        const response = await getRewardsList();

        if (response && response.data && Array.isArray(response.data)) {
          setRewardsData(response.data);
        } else {
          setRewardsData([]);
        }
      } catch (err) {
        setErrorRewards(err.message || "Failed to load rewards");
      } finally {
        setLoadingRewards(false);
      }
    };

    loadRewards();
  }, []);

  const handleRedeem = (rewardIndex) => {
    if (!isAuthenticated()) {
      window.location.href = process.env.REACT_APP_LOGIN_URL;
      return;
    }

    const accessToken = localStorage.getItem("access_token");
    const decoded = jwtDecode(accessToken);

    if (decoded.gn) {
      if (decoded.gn === 1) {
        setShowGameNow(true);
        return;
      }
    }

    const reward = rewardsData[rewardIndex];
    if (!reward) return;

    const profileData = JSON.parse(sessionStorage.getItem("profileData"));
    const ucredits = profileData?.credits;
    console.log(ucredits);
    const remaingCredits = ucredits - reward.credits;
    trackRewardRedemptionAttempt(reward.name, reward.id, reward.credits);

    navigate("/redeem", {
      state: {
        reward,
        gtagItemName: reward.name,
      },
    });
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setMessage(null);
  };

  const getCategory = (reward) => {
    const name = reward.name?.toLowerCase() || "";
    const game = reward.game?.toLowerCase() || "";

    if (name.includes("watch")) return "watches";
    if (name.includes("keyboard")) return "keyboards";
    if (name.includes("airpod") || name.includes("earbud")) return "airpods";
    if (name.includes("head")) return "headsets";
    if (name.includes("mouse")) return "mouse";
    if (game) return "game currencies";

    return "other";
  };

  const CATEGORY_ORDER = {
    watches: 1,
    keyboards: 2,
    airpods: 3,
    headsets: 4,
    mouse: 5,
    "game currencies": 6,
    other: 7,
  };

  const CATEGORY_LABELS = {
    watches: "WATCHES",
    keyboards: "KEYBOARDS",
    airpods: "AIRPODS",
    headsets: "HEADSETS",
    mouse: "MOUSE",
    "game currencies": "GAME CURRENCIES",
    other: "OTHER",
  };

  const CATEGORY_CARD_TYPE = {
    watches: "WATCH",
    keyboards: "KEYBOARD",
    airpods: "AIRPODS",
    headsets: "HEADSET",
    mouse: "MOUSE",
    "game currencies": "CURRENCY",
    other: "OTHER",
  };

  const sortedRewards = [...rewardsData.slice(1)].sort((a, b) => {
    return CATEGORY_ORDER[getCategory(a)] - CATEGORY_ORDER[getCategory(b)];
  });

  const groupedRewards = sortedRewards.reduce((groups, reward) => {
    const cat = getCategory(reward);
    if (!groups[cat]) groups[cat] = [];
    groups[cat].push(reward);
    return groups;
  }, {});

  const getRewardCardClass = (reward, index) => {
    const lower = reward.name?.toLowerCase() || "";
    const game = reward.game?.toLowerCase() || "";

    if (lower.includes("bloody")) return styles.bloodyCard;
    if (lower.includes("edifier")) return styles.edifierCard;
    if (lower.includes("head")) return styles.pinkCard;
    if (lower.includes("mouse")) return styles.goldCard;

    if (game.includes("pubg")) return styles.pubgCard;
    if (game.includes("fortnite")) return styles.fortniteCard;
    if (game.includes("minecraft")) return styles.minecraftCard;

    if (reward.game) {
      if (index % 4 === 0) return styles.blueCard1;
      if (index % 4 === 1) return styles.blueCard2;
      if (index % 4 === 2) return styles.blueCard3;
      return styles.blueCard4;
    }

    return styles.orangeCard;
  };

  return (
    <div className={styles.container}>
      <div className={styles.navigationHeader}>
        <div
          className={styles.navigationBack}
          onClick={() => navigate(-1)}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              navigate(-1);
            }
          }}
        >
          <img src={ArrowLeft} alt="Back" />
        </div>

        <div className={styles.navigationTitle}>
          <p>Game currencies</p>
          <h2 className={styles.heading}>Rewards</h2>
        </div>
      </div>

      {loadingRewards && (
        <div className={styles.loading}>Loading rewards...</div>
      )}

      {errorRewards && (
        <div className={styles.error}>Error: {errorRewards}</div>
      )}

      {!loadingRewards && !errorRewards && (
        <div className={styles.cardGrid}>
          {rewardsData[0] && (
            <div className={styles.featuredCard}>
              <div className={styles.featuredGlow} />

              <div className={styles.featuredContent}>
                <div className={styles.featuredBadges}>
                  <span className={styles.yellowBadge}>⭐ TOP REDEEM</span>
                </div>

                <span className={styles.brand}>SONY</span>

                <h2 className={styles.ps5Title}>PS5</h2>

                <p className={styles.ps5Subtitle}>PlayStation 5 Slim Console</p>

                <div className={styles.featuredFooter}>
                  <div className={styles.creditPill}>
                    <img src={coinImg} alt="Coin" className={styles.coinIcon} />
                    {rewardsData[0].credits?.toLocaleString()}
                  </div>

                  <button
                    className={styles.redeemHeroBtn}
                    onClick={() => handleRedeem(0)}
                    disabled={!rewardsData[0].can_redeem}
                  >
                    {rewardsData[0].can_redeem
                      ? "REDEEM NOW →"
                      : "INSUFFICIENT COINS"}
                  </button>
                </div>
              </div>

              <div className={styles.featuredImageWrap}>
                <img
                  src={getRewardImage(rewardsData[0].name)}
                  alt={rewardsData[0].name}
                  className={styles.featuredImage}
                />
              </div>
            </div>
          )}

          <div className={styles.rewardSections}>
            {Object.entries(groupedRewards)
              .sort(([a], [b]) => CATEGORY_ORDER[a] - CATEGORY_ORDER[b])
              .map(([category, rewards]) => (
                <div key={category} className={styles.section}>
                  <div className={styles.sectionHeader}>
                    <div className={styles.dot} />
                    <span className={styles.sectionTitle}>
                      {CATEGORY_LABELS[category] || category.toUpperCase()}
                    </span>
                    <div className={styles.line} />
                  </div>

                  <div className={styles.sectionCards}>
                    {rewards.map((reward, index) => {
                      const originalRewardIndex = rewardsData.findIndex(
                        (item) => item.id === reward.id,
                      );

                      return (
                        <div
                          key={reward.id || reward.name}
                          className={`${styles.rewardCard} ${getRewardCardClass(
                            reward,
                            index,
                          )}`}
                        >
                          <div className={styles.cardLeft}>
                            <div className={styles.imageBox}>
                              <img
                                src={getRewardImage(reward.name)}
                                alt={reward.name}
                                className={styles.rewardImage}
                              />
                            </div>

                            <span className={styles.cardType}>
                              {CATEGORY_CARD_TYPE[category] || "ITEM"}
                            </span>
                          </div>

                          <div className={styles.cardRight}>
                            <div className={styles.topRow}>
                              <div className={styles.creditRequired}>
                                CREDITS REQUIRED
                              </div>

                              <div className={styles.smallPrice}>
                                <img
                                  src={coinImg}
                                  alt="Coin"
                                  className={styles.coinIcon}
                                />
                                {reward.credits?.toLocaleString()}
                              </div>
                            </div>

                            <div className={styles.rewardInfo}>
                              <span className={styles.rewardBrand}>
                                {reward.game || ""}
                              </span>

                              <h4 className={styles.rewardName}>
                                {reward.name}
                              </h4>
                            </div>

                            <div className={styles.bottomRow}>
                              <span className={styles.premiumBadge}>
                                {reward.game === null ? "PREMIUM" : "STANDARD"}
                              </span>

                              <button
                                className={styles.redeemBtn}
                                onClick={() =>
                                  handleRedeem(originalRewardIndex)
                                }
                                disabled={!reward.can_redeem}
                              >
                                {reward.can_redeem
                                  ? "REDEEM NOW →"
                                  : "INSUFFICIENT COINS"}
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
          </div>

          {isPopupOpen && (
            <MessagePopup
              isOpen={isPopupOpen}
              message={message}
              onClose={handleClosePopup}
            />
          )}

          {showGameNow && (
            <GameNowPopup
              isOpen={showGameNow}
              onClose={() => {
                setShowGameNow(false);
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default Rewards;
